module.exports = __webpack_public_path__ + "img/user_no_image.038449ee.svg";